import React from "react";
import { useHistory } from "react-router-dom";
import smartLendLogo from "./img/sl_long_new_logo_wo_beta.png";

const footerLinks = [
  { label: "Partner with us", path: "/partner-with-us" },
  { label: "FAQ", path: "/frequentlyaskedquestions" },
  { label: "News & Events", path: "/news-events" },
  { label: "Contact us", path: "/contactus" },
];

const NewHomepageFooter = () => {
  const history = useHistory();

  const navigateTo = (path) => {
    history.push(path);
    window.scrollTo(0, 0);
  };

  return (
    <footer
      style={{
        borderTop: "1px solid rgba(37,97,153,0.15)",
        background: "#fff",
        padding: "18px 0",
      }}
    >
      <div
        style={{
          width: "min(1200px, 92vw)",
          margin: "0 auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        <img src={smartLendLogo} alt="SmartLend" style={{ height: "32px" }} />

        <p style={{ margin: 0, color: "#5f6470", fontSize: "14px" }}>
          © {new Date().getFullYear()} SmartLend. All rights reserved.
        </p>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            fontSize: "14px",
            color: "#1f3553",
          }}
        >
          <button
            type="button"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            style={{ background: "none", border: "none", cursor: "pointer", color: "inherit" }}
          >
            Back to top
          </button>
          {footerLinks.map((item) => (
            <button
              key={item.path}
              type="button"
              onClick={() => navigateTo(item.path)}
              style={{ background: "none", border: "none", cursor: "pointer", color: "inherit" }}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default NewHomepageFooter;
